/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import { Modal, ModalBody, Spinner } from 'reactstrap';
import { Button, Checkbox } from 'ui-kit-takeat';
import { FaExclamationTriangle } from 'react-icons/fa';
import InsertPayment from '~/assets/img/insert_payment.jpeg';
import FinishBillsInBatch from '~/components/FinishBillsInBatch';
import { IoCheckmark, IoFilter } from 'react-icons/io5';
import { AutoSizer, List } from 'react-virtualized';
import OrderReadyDelivery from '../../Items/OrderReadyDelivery';
import OrderAndamentoDelivery from '../../Items/OrderAndamentoDelivery';
import {
  Header,
  Bloco,
  StyleKanbanWarning,
  FilterArea,
  ItemsCount,
  OrderArea,
} from './styles';
import { Content, LoadingDiv } from '../styles';
import { EveryOrdersDelivery } from 'components/EveryOrdersDelivery';
import { useAuth } from 'context/AuthContext';

export default function CardOrdersDelivery({
  baskets,
  handleItemFinished,
  handleCancelItem,
  loading,
  handleUpdate,
  hasOrderActive,
  getAllOrders,
  paymentMethods,
  allPaymentMethods,
  favoritePaymentMethods,
  countOrders,
  headerTitle,
  headerColor,
  showFinishBills,
  hasOrderBy,
  hasFilterBy,
  handleItemReady,
}) {
  const [isModalFinishBillsInBatchOpened, setIsModalFinishBillsInBatchOpened] =
    useState(false);
  function toggleModalFinishBillsInBatch() {
    setIsModalFinishBillsInBatchOpened(!isModalFinishBillsInBatchOpened);
  }
  const [isModalConfirmationOpened, setIsModalConfirmationOpened] =
    useState(false);
  function toggleModalConfirmFinishBills() {
    setIsModalConfirmationOpened(!isModalConfirmationOpened);
  }
  const [showPaid, setShowPaid] = useState(true);
  const [showUnpaid, setShowUnpaid] = useState(true);
  const [orderBy, setOrderBy] = useState('created_at');
  const { user } = useAuth();

  const handleFilterChange = (filterType) => {
    if (filterType === 'paid') {
      if (showPaid && !showUnpaid) {
        return;
      }
      setShowPaid(!showPaid);
    } else if (filterType === 'unpaid') {
      if (showUnpaid && !showPaid) {
        return;
      }
      setShowUnpaid(!showUnpaid);
    }
  };

  const [isFilterModalOpened, setIsFilterModalOpened] = useState(false);
  const [isOrderModalOpened, setIsOrderModalOpened] = useState(false);

  function toggleFilterModal() {
    setIsFilterModalOpened(!isFilterModalOpened);
  }

  const areaRef = useRef(null);

  const handleClickOutside = (event) => {
    if (areaRef.current && !areaRef.current.contains(event.target)) {
      setIsFilterModalOpened(false);
      setIsOrderModalOpened(false);
    }
  };

  useEffect(() => {
    if (isFilterModalOpened || isOrderModalOpened) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isFilterModalOpened, isOrderModalOpened]);

  const basketsFiltered = baskets
    .filter((order) => order.table.table_type === 'delivery')
    .filter((item) => {
      if (showPaid && showUnpaid) {
        return true;
      }
      if (showPaid) {
        return item.is_paid === true;
      }
      if (showUnpaid) {
        return item.is_paid === false;
      }
      return false;
    });

  const basketIds = baskets
    .flatMap((item) => item.basket)
    .map((basket) => basket.id);

  const basketIfood = basketsFiltered
    .flatMap((bskt) => bskt)
    .map((baskets) => {
      return baskets.basket.ifood_id;
    });

  const basketWithdrawal = basketsFiltered
    .flatMap((bskt) => bskt)
    .map((baskets) => {
      return baskets.with_withdrawal;
    });

  return (
    <Bloco color={headerColor}>
      {showFinishBills && (
        <>
          <Modal
            isOpen={isModalFinishBillsInBatchOpened}
            toggle={toggleModalFinishBillsInBatch}
            size="lg"
          >
            <FinishBillsInBatch
              isDelivery
              toggleModalFinishBillsInBatch={toggleModalFinishBillsInBatch}
              getSessions={getAllOrders}
            />
          </Modal>

          <Modal
            isOpen={isModalConfirmationOpened}
            toggle={toggleModalConfirmFinishBills}
          >
            <ModalBody>
              <div style={{ textAlign: 'center' }}>
                <FaExclamationTriangle size={40} color="#FFA814" />
                <h1 style={{ fontSize: 18, fontWeight: 'bold', marginTop: 10 }}>
                  Apenas as comandas com ”Método de pagamento” selecionado serão
                  finalizadas.
                </h1>
                <p>Há dois modos de selecionar o “Método de Pagamento”:</p>
                <img
                  src={InsertPayment}
                  alt="Imagem mostrando onde inserir pagamento na comanda"
                />
              </div>
              <footer
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Button
                  inverted
                  buttonColor="#FF2C3A"
                  title="Cancelar"
                  onClick={toggleModalConfirmFinishBills}
                />
                <Button
                  buttonColor={headerColor}
                  title="Confirmar"
                  onClick={() => {
                    toggleModalFinishBillsInBatch();
                    setIsModalConfirmationOpened(false);
                  }}
                />
              </footer>
            </ModalBody>
          </Modal>
        </>
      )}
      <Header color={headerColor}>
        <div
          style={{
            lineHeight: 1.2,
            textAlign: 'left',
          }}
        >
          {headerTitle}
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          {hasFilterBy && (
            <Button
              buttonColor="#1d9688"
              style={{
                marginRight: 8,
                padding: 8,
                height: 32,
              }}
              title="Filtrar"
              icon={<IoFilter color="#fff" size={21} />}
              onClick={toggleFilterModal}
            />
          )}

          <ItemsCount color={headerColor}>{countOrders}</ItemsCount>
          {isFilterModalOpened && (
            <FilterArea ref={areaRef}>
              <p>
                <Checkbox
                  label="Pago"
                  checked={showPaid}
                  onClick={() => handleFilterChange('paid')}
                />
              </p>
              <p>
                <Checkbox
                  label="Não Pagos"
                  checked={showUnpaid}
                  onClick={() => handleFilterChange('unpaid')}
                />
              </p>
            </FilterArea>
          )}
          {isOrderModalOpened && (
            <OrderArea ref={areaRef}>
              <button
                onClick={() => {
                  setOrderBy('created_at');
                  setIsOrderModalOpened(false);
                }}
                type="button"
              >
                Data de criação
                {orderBy === 'created_at' && (
                  <IoCheckmark size={22} color="#2EC9B7" />
                )}
              </button>
              <button
                onClick={() => {
                  setOrderBy('neighborhood');
                  setIsOrderModalOpened(false);
                }}
                type="button"
              >
                Bairro
                {orderBy === 'neighborhood' && (
                  <IoCheckmark size={22} color="#2EC9B7" />
                )}
              </button>
            </OrderArea>
          )}
        </div>
      </Header>

      <Content>
        {showFinishBills && (
          <Button
            title="Finalizar comandas"
            onClick={() => {
              toggleModalConfirmFinishBills();
            }}
            containerStyles={{
              width: '-webkit-fill-available',
              height: 30,
            }}
            inverted
            buttonColor={headerColor}
          />
        )}
        {loading ? (
          <LoadingDiv>
            <Spinner color="pink" />
          </LoadingDiv>
        ) : (
          <AutoSizer>
            {({ width, height }) => (
              <List
                width={width}
                height={height - (showFinishBills ? 30 : 0)}
                rowCount={basketsFiltered.length}
                rowHeight={({ index }) => {
                  const item = basketsFiltered[index];
                  if (
                    headerTitle === 'EM ROTA' &&
                    item.ifood_delivery_time &&
                    item.motoboy
                  ) {
                    return 280;
                  } else if (
                    user.use_foody_delivery &&
                    item.ifood_delivery_time &&
                    headerTitle === 'EM ROTA'
                  ) {
                    return 255;
                  } else if (
                    item.ifood_delivery_time &&
                    item.motoboy &&
                    headerTitle !== 'EM ROTA'
                  ) {
                    return 260;
                  } else if (
                    item.ifood_delivery_time &&
                    headerTitle !== 'EM ROTA'
                  ) {
                    return 255;
                  } else if (item.with_withdrawal && item.ifood_delivery_time) {
                    return 230;
                  } else if (item.with_withdrawal) {
                    return 210;
                  }
                  return 230;
                }}
                rowRenderer={({ index, key, style }) => {
                  const item = basketsFiltered[index];
                  return hasFilterBy ? (
                    <OrderReadyDelivery
                      key={item.session_id}
                      style={style}
                      handleCancelItem={handleCancelItem}
                      handleItemFinished={handleItemFinished}
                      item={item}
                      paymentMethods={paymentMethods}
                      allPaymentMethods={allPaymentMethods}
                      favoritePaymentMethods={favoritePaymentMethods}
                      getAllOrders={getAllOrders}
                      handleUpdate={handleUpdate}
                    />
                  ) : (
                    //monta os pedidos de ready e ongoing

                    <OrderAndamentoDelivery
                      key={item.session_id}
                      style={style}
                      handleCancelItem={handleCancelItem}
                      handleItemFinished={handleItemFinished}
                      item={item}
                      handleItemReady={handleItemReady}
                      handleUpdate={handleUpdate}
                      hasOrderBy={hasOrderBy}
                      isOngoing={!hasOrderBy && !hasFilterBy}
                    />
                  );
                }}
              />
            )}
          </AutoSizer>
        )}
        {!hasOrderActive && (
          <StyleKanbanWarning>
            <p style={{ color: '#666666' }}>Não há pedido</p>
            <p style={{ color: '#666666' }}>no momento</p>
          </StyleKanbanWarning>
        )}
      </Content>
      {headerTitle === 'PRONTO' && (
        <EveryOrdersDelivery
          baskets={basketsFiltered}
          basketId={basketIds}
          basketStatus={['ready']}
          basketIfood={basketIfood}
          basketWithdrawal={basketWithdrawal}
        />
      )}
      {headerTitle === 'EM ROTA' && (
        <EveryOrdersDelivery
          baskets={basketsFiltered}
          basketId={basketIds}
          basketStatus={['ongoing']}
          basketIfood={basketIfood}
          basketWithdrawal={basketWithdrawal}
        />
      )}
    </Bloco>
  );
}
